import React, { useLayoutEffect } from "react"
import {
  TextInput as PrimitiveTextInput,
  NativeSyntheticEvent,
  TextInputSelectionChangeEventData,
  TextInputRef,
} from "~/ui/primitives"
import styled from "~/ui/styled"

interface Props {
  inputRef: React.RefObject<TextInputRef>
  content: string
  onKeyPress: (key: string) => void
  onSelectionChange?: (e: NativeSyntheticEvent<TextInputSelectionChangeEventData>) => void
  onChangeText: (t: string) => void
  onSubmit?: () => void
  onFocus?: () => void
  onBlur?: () => void
  autoFocus?: boolean
  editable?: boolean
  placeholder?: string
}

const MAX_INPUT_HEIGHT = 120

const TextInput = styled.TextInput`
  flex: 1;
  min-width: 0;
  align-self: center;
  min-height: 0;
  height: auto;
  max-height: ${MAX_INPUT_HEIGHT}px;
  padding: 3px 12px 2px 0;
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1.4;
  border: none;
  outline: none;
  background: transparent;
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;
`

function syncTextareaHeight(el: HTMLTextAreaElement | null) {
  if (!el) return
  el.style.height = "auto"
  el.style.height = `${Math.min(el.scrollHeight, MAX_INPUT_HEIGHT)}px`
}

// 文本消息输入组件
const MessageTextInput: React.FC<Props> = ({
  inputRef,
  onKeyPress,
  onSelectionChange,
  onChangeText,
  content,
  onSubmit,
  onFocus,
  onBlur,
  editable,
  placeholder,
}) => {
  useLayoutEffect(() => {
    syncTextareaHeight(inputRef.current as HTMLTextAreaElement | null)
  }, [content, editable, inputRef])

  return (
    <TextInput
      ref={inputRef}
      onKeyPress={onKeyPress ? (e) => onKeyPress(e.nativeEvent.key) : undefined}
      onSelectionChange={onSelectionChange}
      onChangeText={onChangeText}
      value={content}
      placeholder={placeholder}
      onSubmitEditing={() => onSubmit?.()}
      onFocus={onFocus}
      onBlur={onBlur}
      editable={editable}
      multiline
      numberOfLines={1}
      blurOnSubmit={false}
      autoCapitalize="none"
      textAlignVertical="top"
      includeFontPadding={false}
      underlineColorAndroid="transparent"
    />
  )
}
export default MessageTextInput
